import(/* webpackMode: "eager" */ "/vercel/path0/src/app/feedback/page.tsx");
